module.exports = __webpack_public_path__ + "img/group25@2x-vi.301db6ab.png";